import { Alert } from "@mui/material";
import React from "react";
import { FallbackProps } from "react-error-boundary";
import "./styles.scss";

const ErrorComponent: React.FC<FallbackProps> = () => {
  return (
    <div className="errorComponent__root">
      <Alert variant="outlined" severity="error" className="errorComponent__alert">
        An error occured. Our system may not work or you made unexpected action.
      </Alert>
    </div>
  );
};

export default ErrorComponent;
